import React, { useEffect, useState } from 'react';
import { useDebounce } from 'hooks/useDebounce';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { Button } from 'primereact/button';

export const DiscrepancyFilter = ({ searchKey, setSearchKey, refreshDiscrepancies, limit, id }) => {
  const [searchInput, setSearchInput] = useState(searchKey);
  const debouncedSearch = useDebounce(searchInput, 300); // 300ms debounce delay

  // Update the actual searchKey when debounced value changes
  useEffect(() => {
    setSearchKey(debouncedSearch);
  }, [debouncedSearch, setSearchKey]);

  const handleReload = () => {
    setSearchKey('');
    setSearchInput('');
    refreshDiscrepancies(limit, '', id);
  };

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between mb-2 col-12 FM-filter">
      <div className="filter-wrap d-flex flex-grow-1 align-items-center justify-content-between p-2">
        <div className="d-flex align-items-center filtersearch pe-lg-4 autowidth p-2 p-lg-0">
          <div className="p-input-icon-left input-shadow w-100 ">
            <i className="icon-search F-size16" />
            <TextSnippetWrapper
              type="text"
              placeholder="Search"
              onChange={(e) => setSearchInput(e.target.value)}
              value={searchInput}
              className="p-inputtext p-component input-search"
              autoComplete="off"
            />
          </div>
        </div>
        <div className="d-flex align-items-center">
          <Button
            icon="fas fa-sync-alt"
            className="p-button-text p-button-sm"
            onClick={handleReload}
            tooltip="Reload Discrepancies"
            tooltipOptions={{ position: 'top' }}
            aria-label="Reload Discrepancies"
          />
        </div>
      </div>
    </div>
  );
};

export default DiscrepancyFilter;
